var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-backgroundbackground"},[_c('div',{staticClass:"video-background",style:({'background-color': _vm.backgroundColor })}),_vm._v(" "),_c('div',{ref:"darkener",staticClass:"darken"})])}
var staticRenderFns = []

export { render, staticRenderFns }